import {EventHappening} from "@/lib/types";
import {StyleSheet} from "react-native";
import {router} from "expo-router";
import {Color} from "@/lib/styles";
import Card from "@/lib/components/Card";
import Timestamp from "@/lib/components/Timestamp";
import Location from "@/lib/components/Location";

type Props = {
    event: EventHappening,
}

// Preview event card for lists.
export default function EventCard({event}: Props) {
    function onPress() {
        router.navigate(`/e/${event.event_id}`);
    }

    return (
        <Card onPress={onPress}
              image_url={event.image_url}
              color={event.color}
              contrast_color={event.contrast_color}
              title={event.title}>
            <Timestamp start={new Date(event.start)} end={event.end ? new Date(event.end) : null} oneLineOnly={true}/>
            {event.location && <Location>{event.location}</Location>}
        </Card>
    )
}

export const styles = StyleSheet.create({
    text: {
        color: Color.PrimaryText,
        fontSize: 16,
        lineHeight: 26,
        width: "100%",
    },
})